import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'material-ui/DatePicker';
import getTheme from '../MuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

var LLDatePicker = /*#__PURE__*/function (_Component) {
  _inherits(LLDatePicker, _Component);

  var _super = _createSuper(LLDatePicker);

  function LLDatePicker() {
    var _this;

    _classCallCheck(this, LLDatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "dateSelected", function (event, date) {
      if (_this.props.onChange) {
        _this.props.onChange(date);
      }
    });

    return _this;
  }

  _createClass(LLDatePicker, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(DatePicker, {
        firstDayOfWeek: 0,
        minDate: this.props.min,
        maxDate: this.props.max,
        id: this.props.id,
        style: this.props.style,
        hintText: this.props.placeholder,
        value: this.props.value,
        onChange: this.dateSelected
      });
    }
  }]);

  return LLDatePicker;
}(Component);

_defineProperty(LLDatePicker, "propTypes", {
  placeholder: PropTypes.string,
  style: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string
});

_defineProperty(LLDatePicker, "defaultProps", {
  placeholder: '',
  type: null,
  style: {},
  value: '',
  onChange: null,
  id: null
});

export { LLDatePicker as default };